/*
 * Themporium page motion: sections drift into view as you scroll, and the starry backdrop
 * moves slowly behind the page. Decorative only; skipped for visitors who prefer reduced motion.
 */
(function () {
  'use strict';
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var root = document.documentElement;

  // Star backdrop parallax
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      root.style.setProperty('--tp-scroll', String(Math.round(window.scrollY)));
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  // Reveal on scroll
  if (!('IntersectionObserver' in window)) return;
  var SELECTOR = '.tp-section-head, .tp-chapter, .tp-story-art, .tp-story-copy, .tp-finder-card, .tp-trust-item, .tp-gf-head, .tp-gf-step';
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-in');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });

  function prepare(scope) {
    scope.querySelectorAll(SELECTOR).forEach(function (el) {
      if (el.classList.contains('tp-reveal')) return;
      // Stagger siblings of the same kind (the four chapters, the three promises)
      var index = Array.prototype.indexOf.call(el.parentNode.children, el);
      el.style.setProperty('--tp-i', String(Math.min(index, 6)));
      el.classList.add('tp-reveal');
      observer.observe(el);
    });
  }

  root.classList.add('tp-motion');
  prepare(document);
  // Theme editor: sections re-render when edited
  document.addEventListener('shopify:section:load', function (e) { prepare(e.target); });
})();
